<template>
  <div class="full-carousel-banner flex" @mouseenter="clearTimer" @mouseleave="startTimer">
    <div class="carousel-banner flex-2">
      <div class="carousel-banner__wrapper h-full overflow-hidden relative">
        <button @click="prevSlide" class="carousel-banner__btn-prev">
          <i class="far fa-angle-left"></i>
        </button>
        <ul :style="listStyle" class="carousel-banner__list flex h-full absolute top-0 bottom-0 left-0 right-0">
          <li v-for="(item, index) in sliderContent" :key="index" class="carousel-banner__item w-full">
            <a href="/" class="carousel-banner__item__link h-full block">
              <div class="carousel-banner__item__image bg-cover" :style="url(item.url)"></div>
            </a>
          </li>
        </ul>
        <button @click="nextSlide" class="carousel-banner__btn-next">
          <i class="far fa-angle-right"></i>
        </button>
      </div>
    </div>

    <div class="sub-banner flex flex-col ml-2 flex-1 m-t-1023-none">
      <a href="" class="sub-banner1__item__img flex-50% block">
        <div class="sub-banner__item__img h-full"></div>
      </a>
      <a href="" class="sub-banner2__item__img mt-2 flex-50% block">
        <div class="sub-banner__item__img h-full"></div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselBanner",
  data() {
    return {
      index: 0,
      sliderContent: [
        {
          url: 'https://cf.shopee.co.th/file/th-50009109-648745d95b9ad38bdd988766423993f0_xxhdpi'
        },
        {
          url: 'https://cf.shopee.co.th/file/th-50009109-53a96088dd7573e911576540c6066059_xxhdpi'
        },
        {
          url: 'https://cf.shopee.co.th/file/th-50009109-24c778f345925b8da09f04c41c130025_xxhdpi'
        },
        {
          url: 'https://cf.shopee.co.th/file/th-50009109-af3397c4be0f68bd60f0dfef0c56902f_xxhdpi'
        },
        {
          url: 'https://cf.shopee.co.th/file/th-50009109-0ca85d6963d4706ec4399f7c1e15b174_xxhdpi'
        }
      ],
      timer: null
    };
  },
  computed: {
    listStyle() {
      return {
        width: `${this.sliderContent.length * 100}%`,
        transform: `translateX(-${this.index * 100 / this.sliderContent.length}%)`
      };
    }
  },
  methods: {
    url(url) {
      return `background-image: url(${url});`;
    },
    nextSlide() {
      if (this.index < this.sliderContent.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
    },
    prevSlide() {
      if (this.index > 0) {
        this.index--;
      } else {
        this.index = this.sliderContent.length - 1;
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 3000); // Adjust interval as per your preference (in milliseconds)
    },
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    autoSlideNext() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 3000); // Adjust interval as per your preference (in milliseconds)
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.full-carousel-banner {
  height: 23.5rem;
  width: 100%;
}

.carousel-banner__list {
  transition: all 500ms ease 0s;
}

.carousel-banner__item {
  min-height: 23.5rem;
  max-height: 23.5rem;
}

.carousel-banner__item__link {
  width: 100%;
}

.carousel-banner__item__image {
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}

.sub-banner1__item__img {
  background-image: url("https://cf.shopee.co.th/file/th-50009109-e4fc7813eb0f9be99291304bc07ef170_xhdpi");
  background-repeat: no-repeat;
  background-size: cover;
}

.sub-banner2__item__img {
  background-image: url("https://cf.shopee.co.th/file/th-50009109-e6ba1732b8e2fbd96a42881f1a6aeb31_xhdpi");
  background-repeat: no-repeat;
  background-size: cover;
}

.carousel-banner__btn-prev,
.carousel-banner__btn-next {
  position: absolute;
  z-index: 2;
  width: 3.4rem;
  height: 5.4rem;
  background-color: rgba(0, 0, 0, .32);
  font-size: 3rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-white-color);
}

.carousel-banner__btn-prev {
  left: 0;
}

.carousel-banner__btn-next {
  right: 0;
}
</style>
